const bookingFlowRoutes = {
  OVERVIEW: '/',
  INFORMATION: '/information',
  SUMMARY: '/summary',
  THANKS: '/thanks',
} as const;

export default bookingFlowRoutes;
